/*
 * @Author: jzh
 * @Date: 2020-03-16 15:50:17
 * @Description: file content
 * @LastEditTime: 2020-08-20 11:54:31
 * @LastEditors: DQL
 */

import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

function rd () {
  return new Date().getTime();
}

// 岗位分类
export const queryRoleType = (params) => { return axios.get(`${commontCtx}/roleType/list`, { params, _: rd() }); };

// 岗位
export const roleService = {
  queryRole: (params) => { return axios.get(`${commontCtx}/role/query`, { params, _: rd() }); },

  listRole: (params) => { return axios.get(`${commontCtx}/role/list`, { params, _: rd() }); },

  getRole: (roleCode) => { return axios.get(`${commontCtx}/role/get/${roleCode}`); },

  addRole: (fd) => { return axios.post(`${commontCtx}/role/save`, fd); },

  updateRole: (fd) => { return axios.put(`${commontCtx}/role/update`, fd); },

  deleteRole: (roleCode) => { return axios.delete(`${commontCtx}/role/delete/${roleCode}`); },

  getAppList: () => { return axios.get(`${commontCtx}/app/list`); },

  // 获取管理员级别以及权限信息
  getPermission: () => { return axios.get(`${commontCtx}/role/admin/permission`); }
};

// 岗位关联部门
export const deptRoleService = {

  getByRoleCode: (roleCode) => { return axios.get(`${commontCtx}/deptRole/role/${roleCode}`); },

  saveByRoleCode: (fd) => { return axios.post(`${commontCtx}/deptRole/role/save`, fd); },

  getByDeptCode: (roleCode) => { return axios.get(`${commontCtx}/deptRole/dept/${roleCode}`); },

  saveByDeptCode: (fd) => { return axios.post(`${commontCtx}/deptRole/dept/save`, fd); }
};

// 岗位菜单维护
export const menuRoleService = {

  getByRoleCode: (roleCode) => { return axios.get(`${commontCtx}/role/element/${roleCode}`); },

  saveByRoleCode: (roleCode, fd) => { return axios.post(`${commontCtx}/role/element/${roleCode}`, fd); }
};

// 查询机构部门树
export const deptTree = (params) => { return axios.get(`${commontCtx}/dept/tree/async`, { params }); };
// 查询菜单部门树
export const menuTree = (securityType) => { return axios.get(`${commontCtx}/menu/v2/getTree/${securityType}`); };
